import {
    TContentHubSeriesOverviewProps,
    TGalleryItem,
  } from "../types/ContentHubSeriesOverview.type";

  export class ExpandableOverlayModel {
    private readonly fields?;

    constructor(props: TContentHubSeriesOverviewProps) {
      this.fields = props.fields || null;
    }

    get slides(): Array<TGalleryItem> {
      return this.fields?.apiData?.assets;
    }

    get video(): string {
      return this.fields?.apiData?.videoUrl || "";
    }

    get videoDescription(): string {
      return this.fields?.apiData?.videoDescription || "";
    }

    get title(): string {
      return this.fields?.apiData?.title || "";
    }

    get description(): string {
      return this.fields?.apiData?.description || "";
    }
  }
